import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { loginByUsername, logout, getUserInfo } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";
import jwtDecode from "jwt-decode";
var user = {
  state: {
    _id: "",
    user: "",
    email: "",
    status: "",
    code: "",
    acl: "",
    token: getToken(),
    name: "",
    org: "",
    avatar: "",
    introduction: "",
    roles: [],
    setting: {
      articlePlatform: []
    }
  },
  mutations: {
    SET_CODE: function SET_CODE(state, code) {
      state.code = code;
    },
    SET_ID: function SET_ID(state, id) {
      state._id = id;
    },
    SET_EMAIL: function SET_EMAIL(state, email) {
      state.email = email;
    },
    SET_ACL: function SET_ACL(state, acl) {
      state.acl = acl;
    },
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_ORG_ID: function SET_ORG_ID(state, orgId) {
      state.org = orgId;
    },
    SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
      state.introduction = introduction;
    },
    SET_SETTING: function SET_SETTING(state, setting) {
      state.setting = setting;
    },
    SET_STATUS: function SET_STATUS(state, status) {
      state.status = status;
    },
    SET_NAME: function SET_NAME(state, name) {
      state.name = name;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    }
  },
  actions: {
    // 用户名登录
    LoginByUsername: function LoginByUsername(_ref, userInfo) {
      var commit = _ref.commit;
      var username = userInfo.username.trim();
      return new Promise(function (resolve, reject) {
        loginByUsername(username, userInfo.password).then(function (response) {
          var data = response.data;
          commit("SET_TOKEN", data.accessToken);
          commit("SET_ID", data.user._id);
          setToken(data.accessToken, userInfo.cookieExpires);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 获取用户信息
    GetUserInfo: function GetUserInfo(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state,
          dispatch = _ref2.dispatch;
      return new Promise(function (resolve, reject) {
        getUserInfo(jwtDecode(state.token).userId).then( /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
            var data, roles;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!response.data) {
                      // 由于mockjs 不支持自定义状态码只能这样hack
                      reject("error");
                    }

                    data = response.data;
                    roles = [data.role];

                    if (data.role && data.role.length > 0) {
                      // 验证返回的roles是否是一个非空数组
                      // HIDEME: console.log(data);
                      commit("SET_ROLES", roles);
                    } else {
                      reject("getInfo: roles must be a non-null array !");
                    }

                    commit("SET_NAME", data.name);
                    commit("SET_ID", data._id);
                    commit("SET_EMAIL", data.email);
                    commit("SET_ACL", data.acl);
                    commit("SET_AVATAR", data.avatar);
                    commit("SET_ORG_ID", data.org);
                    _context.next = 12;
                    return dispatch("updateCurrentOrgId", data.org, {
                      root: true
                    });

                  case 12:
                    // commit('SET_INTRODUCTION', data.introduction)
                    resolve(response);

                  case 13:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }()).catch(function (error) {
          reject(error);
        });
      });
    },
    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // 登出
    LogOut: function LogOut(_ref4) {
      var commit = _ref4.commit,
          state = _ref4.state;
      return new Promise(function (resolve, reject) {
        logout(state.token).then(function () {
          commit("SET_TOKEN", "");
          commit("SET_ROLES", []);
          removeToken();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 前端 登出
    FedLogOut: function FedLogOut(_ref5) {
      var commit = _ref5.commit;
      return new Promise(function (resolve) {
        commit("SET_TOKEN", "");
        removeToken();
        resolve();
      });
    },
    // 动态修改权限
    ChangeRoles: function ChangeRoles(_ref6, role) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;
      return new Promise(function (resolve) {
        commit("SET_TOKEN", role);
        setToken(role);
        getUserInfo(role).then(function (response) {
          var data = response.data;
          commit("SET_ROLES", data.roles);
          commit("SET_NAME", data.name); // commit('SET_AVATAR', data.avatar)
          // commit('SET_INTRODUCTION', data.introduction)

          dispatch("GenerateRoutes", data); // 动态修改权限后 重绘侧边菜单

          resolve();
        });
      });
    }
  }
};
export default user;